'use client'

export const dynamic = 'force-dynamic'

import { AuthForm } from '../AuthForm'

export default function LoginPage() {
  return <AuthForm initialMode="login" />
}
